import React from 'react'
import {
    BackButton,
    Bloc,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

/*
    Etape intermédiaire affichée uniquement quand l'utilisateur a répondu
    "J'ai trouvé mon bien" (prj_maturite = TROUVE) sur Vue1.
    Ne modifie jamais prj_maturite : le dépôt en fin de tunnel reste en mode
    "trouver" (EnregistrerDossierTrouver), que le compromis soit signé ou non.
*/
export default function Vue28() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Estimez votre crédit immobilier"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={5} time={5} />
            </div>

            <div className="Container">
                <div className="Bloc bloc-full" style={{ paddingTop: 10, paddingBottom: 10 }}>
                    <div className="labelfield">
                        Avez-vous déjà signé un compromis ou une promesse de
                        vente ?
                    </div>
                </div>

                {/* Si esquive du choix de type (car preselectionné) */}
                <Conditionnal
                    linked_data_id="tech_esquiver_prj_type"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <Bloc
                        key="key200"
                        selectable
                        linked_data_id="prj_signe_compromis"
                        linked_data_value="OUI"
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Oui"
                    />
                    <Bloc
                        key="key201"
                        selectable
                        linked_data_id="prj_signe_compromis"
                        linked_data_value="NON"
                        targetView={3}
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Non"
                    />
                </Conditionnal>

                {/* Si on esquive pas le choix de type (car preselectionné) */}
                <Conditionnal
                    linked_data_id="tech_esquiver_prj_type"
                    isNotEqualTo
                    targetDataValueCompare={true}
                >
                    <Bloc
                        key="key202"
                        selectable
                        linked_data_id="prj_signe_compromis"
                        linked_data_value="OUI"
                        targetView={2}
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Oui"
                    />
                    <Bloc
                        key="key203"
                        selectable
                        linked_data_id="prj_signe_compromis"
                        linked_data_value="NON"
                        targetView={2}
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Non"
                    />
                </Conditionnal>
            </div>
        </div>
    )
}
